// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const content = "CreditLinkage__content__PZs3o";
export const creditLinkage = "CreditLinkage__creditLinkage__eusaq";
export const errorButtonContainer = "CreditLinkage__errorButtonContainer__Zpp+L";
export const errorButtons = "CreditLinkage__errorButtons__LMUkt";
export const formButtonContainer = "CreditLinkage__formButtonContainer__Xq0IZ";
export const formButtonContainerFirst = "CreditLinkage__formButtonContainerFirst__1qtXi";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const spinner = "CreditLinkage__spinner__KIGpT";
export const spinnerBlockWrapper = "CreditLinkage__spinnerBlockWrapper__YMny7";
export const spinnerCaption = "CreditLinkage__spinnerCaption__AZkxA";
export const spinnerWrapper = "CreditLinkage__spinnerWrapper__484Hu";
export const subheaderParagraph = "CreditLinkage__subheaderParagraph__nWUrb";
export const subtitleHighlighted = "CreditLinkage__subtitleHighlighted__m6hJ7";
export const subtitleHighlightedAnimation = "CreditLinkage__subtitleHighlightedAnimation__ItGH1";
export const transunionBadge = "CreditLinkage__transunionBadge__MIVLc";